import React from "react";
import styled from "@emotion/styled";
import { useRecoilValue } from "recoil";

// store
import { isMobileWidthAtom } from "store/ui/atom";

// assets
import BgCircleGSVG from "assets/images/pc/bg_circle_g.svg";

const GlobalService = () => {
  const isMobileWidth = useRecoilValue(isMobileWidthAtom);

  if (isMobileWidth) {
    return (
      <FloatMobileRoot>
        <div>
          <img
            src={BgCircleGSVG}
            className="bg_circle_g"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-delay="300"
          />
          <img
            src={require("assets/images/pc/GlobalService.png")}
            className="innovation"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-delay="300"
          />
        </div>
      </FloatMobileRoot>
    );
  } else {
    return (
      <FloatRoot>
        <img
          src={BgCircleGSVG}
          className="bg_circle_g"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="300"
        />
        <img
          src={require("assets/images/pc/GlobalService.png")}
          className="innovation"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="300"
        />
      </FloatRoot>
    );
  }
};

export default GlobalService;

const FloatRoot = styled.div`
  & .bg_circle_g {
    position: absolute;
    margin: -440px 0 0 -70px;
  }
  & .innovation {
    position: absolute;
    margin: -200px 0 0 40px;
    z-index: 1;
  }
`;

const FloatMobileRoot = styled.div`
  position: absolute;
  top: 700px;
  right: 0;
  width: 190px;
  height: 440px;
  overflow: hidden;
  z-index: 10;

  & .bg_circle_g {
    width: 200px;
    position: absolute;
    margin: 0 0 0 100px;
  }
  & .innovation {
    width: 500px;
    position: absolute;
    margin: 170px 0 0 0;
    z-index: 1;
  }
`;
